import { ClientDispatcher } from './index';

export const CLIENT_DISPATCHER_MODULE = 'ClientDispatcher' as const;

let dispatcher: ClientDispatcher;

export const getClientDispatcher = (): ClientDispatcher => {
	if (!dispatcher) {
		dispatcher = new ClientDispatcher();
		// Handle the server hangup scenarios
		dispatcher.register(CLIENT_DISPATCHER_MODULE, dispatcher._abort.bind(dispatcher));
	}
	return dispatcher;
};
